let state = {
    tasks: [

         {
           "id":"1",
            "fullName": "Antonio Mcdaniel",
            "email": "Antonio@nebulean.com",
          },
          {
            "id":"2",
             "fullName": "Ashley Mcdaniel",
             "email": "ashleymcdaniel@nebulean.com",
           },
       
    ],

}

export default state